<div class="container-fluid pt-1 pb-1">
   <div class="row mt-4 mb-4">
      <div class="offset-md-1 col-lg-4 col-md-10 col-12">
         <h4 class="demo-section-title mb-4 text-dark">{{ translatePath + 'writeMessage' | translate }}</h4>
         <form [formGroup]="messageForm">
            <div class="form-group">
               <input
                  [ngClass]="{
                     'is-invalid': messageForm.get('name')?.invalid && messageForm.get('name')?.touched,
                     'is-valid': messageForm.get('name')?.valid
                  }"
                  type="text"
                  formControlName="name"
                  class="form-control"
                  id="userName"
                  [placeholder]="translatePath + 'form.nameSurname' | translate"
               />
               <div class="invalid-feedback" *ngIf="messageForm.get('name')?.hasError('required')">
                  {{ 'validation-errors.required' | translate }}
               </div>
            </div>
            <div class="form-group has-error">
               <input
                  [ngClass]="{
                     'is-invalid': messageForm.get('email')?.invalid && messageForm.get('email')?.touched,
                     'is-valid': messageForm.get('email')?.valid
                  }"
                  type="email"
                  formControlName="email"
                  class="form-control"
                  id="userEmail"
                  [placeholder]="translatePath + 'form.email' | translate"
               />
               <div class="invalid-feedback" *ngIf="messageForm.get('email')?.hasError('email')">
                  {{ 'validation-errors.invalid-email' | translate }}
               </div>
               <div class="invalid-feedback" *ngIf="messageForm.get('email')?.hasError('required')">
                  {{ 'validation-errors.required' | translate }}
               </div>
               <div class="invalid-feedback" *ngIf="messageForm.get('email')?.hasError('validationErrors')">
                  <div *ngFor="let item of messageForm.get('email')?.getError('validationErrors')">
                     {{ 'validation-errors.' + item | translate }}
                  </div>
               </div>
            </div>
            <div class="form-group">
               <textarea
                  [ngClass]="{
                     'is-invalid': messageForm.get('message')?.invalid && messageForm.get('message')?.touched,
                     'is-valid': messageForm.get('message')?.valid
                  }"
                  class="form-control"
                  formControlName="message"
                  style="resize: none"
                  id="userMessage"
                  rows="6"
                  [placeholder]="translatePath + 'form.message' | translate"
               ></textarea>
               <div class="invalid-feedback" *ngIf="messageForm.get('message')?.hasError('required')">
                  {{ 'validation-errors.required' | translate }}
               </div>
            </div>
            <button
               (click)="onSubmit()"
               type="submit"
               [disabled]="!messageForm.valid"
               class="btn btn-primary d-none d-md-block"
            >
               {{ translatePath + 'form.submit' | translate }}
            </button>
         </form>
      </div>
      <div class="offset-md-1 col-lg-2 col-md-4 col-12 mt-lg-0 mt-4">
         <h4 class="demo-section-title mb-4 text-dark">{{ translatePath + 'title' | translate }}</h4>
         <div class="row">
            <div class="col-md-12">
               <h6>{{ translatePath + 'form.email' | translate }}</h6>
            </div>
            <div class="col-md-12">
               <a class="font-weight-normal" href="mailto:suport.mdelivery@egov.md">suport.mdelivery@egov.md</a>
            </div>
         </div>
         <div class="row mt-3">
            <div class="col-md-12">
               <h6>{{ translatePath + 'phone' | translate }}</h6>
            </div>
            <div class="col-md-12">
               <a href="tel: (+373) (22) 820 023">(+373) (22) 820 023</a>
            </div>
            <div class="col-md-12">
               <a href="tel: (+373) (79) 888 328">(+373) (79) 888 328</a>
            </div>
         </div>
         <div class="row mt-3">
            <div class="col-md-12">
               <h6>{{ translatePath + 'address' | translate }}</h6>
            </div>
            <div class="col-md-12">
               <span>bd.Ștefan cel Mare și Sfînt 134, </span>
            </div>
            <div class="col-md-12">
               <span>MD-2012, mun. Chișinău</span>
            </div>
            <div class="col-md-12">
               <span>Republica Moldova</span>
            </div>
         </div>
      </div>
      <div class="offset-md-1 col-lg-2 col-md-5 col-12">
         <div class="row mt-md-5">
            <div class="col-md-12 mt-3">
               <h6>{{ translatePath + 'workingHoursTitle' | translate }}</h6>
            </div>
            <div class="col-md-12">
               <span>{{ translatePath + 'workingHoursContent' | translate }}</span>
            </div>
            <div class="col-md-12">
               <span>{{ translatePath + 'dayOffContent' | translate }}</span>
            </div>
         </div>
         <div class="row mt-4">
            <div class="col-md-12">
               <h6>{{ translatePath + 'weInSocialMedia' | translate }}</h6>
            </div>
            <div class="col-12 mt-2">
               <ul class="list-inline d-flex justify-content-sm-around justify-content-md-start">
                  <li class="list-inline-item">
                     <a href="https://www.facebook.com/eGovernanceAgency.Moldova" target="_blank">
                        <button type="button" class="btn btn-circle bg-blue">
                           <i class="fab fa-facebook-f"></i>
                        </button>
                     </a>
                  </li>
                  <li class="list-inline-item">
                     <a href="https://www.youtube.com/channel/UCQiYfbOzuf2A4GH2R_inZfQ" target="_blank">
                        <button type="button" class="btn btn-circle bg-red">
                           <i class="fab fa-youtube"></i>
                        </button>
                     </a>
                  </li>
                  <li class="list-inline-item">
                     <a href="https://twitter.com/eGovCenterMD" target="_blank">
                        <button type="button" class="btn btn-circle bg-cyan">
                           <i class="fab fa-twitter"></i>
                        </button>
                     </a>
                  </li>
                  <li class="list-inline-item">
                     <a href="https://www.linkedin.com/company/e-government-center/" target="_blank">
                        <button type="button" class="btn btn-circle bg-blue">
                           <i class="fab fa-linkedin-in"></i>
                        </button>
                     </a>
                  </li>
               </ul>
            </div>
         </div>
      </div>
   </div>
</div>
<iframe
   src="https://maps.google.com/maps?q=Agetia%20de%20guvernare%20electronica&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed&amp;z=17&amp;ll=47.0259, 28.8377"
></iframe>
